import { ListItemAvatar, ListItemSecondaryAction, ListItemText, Skeleton, ListItemButton } from '@mui/material';

const NotificationSkeletons = () => {
  return (
    <ListItemButton>
      <ListItemAvatar>
        <Skeleton variant="circular" width={40} height={40} />
      </ListItemAvatar>
      <ListItemText primary={<Skeleton variant="text" />} secondary={<Skeleton variant="text" width={40} />} />
      <ListItemSecondaryAction>
        <Skeleton variant="text" width={40} />
      </ListItemSecondaryAction>
    </ListItemButton>
  );
};

export default NotificationSkeletons;
